module.exports = __webpack_public_path__ + "img/strategy_term.25a21267.png";